/* @flow */

import React from 'react';
import Immutable from 'immutable';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';

export default class MenuListItem extends React.Component {
  static propTypes = {
    item: PropTypes.immutable.map.isRequired,
  }

  _renderChildren = () => {
    const items = this.props.item.get('items', Immutable.List()).map((item, key) => {
      return (
        <MenuListItem
          key={key}
          item={item} />
      );
    });
    if (items.count() > 0) {
      return (
        <ul>
          {items}
        </ul>
      );
    }
  }

  render(): ?React.Element<any> {
    const { item } = this.props;

    const href = item.get('href');
    let label = item.get('label');

    if (item.get('isPDF') || item.get('isExternal')) {
      label += " ";
    }

    const title = (href) ? (
      <a href={href} target="_blank">
        {label}
        {item.get('isPDF') &&
          <FontAwesome
            name="file-pdf-o"
            ariaLabel="[PDF]" />
        }
        {item.get('isExternal') &&
          <FontAwesome
            name="external-link"
            ariaLabel="[External Site]" />
        }
      </a>
    ) : label;

    return (
      <li>
        {title}
        {this._renderChildren()}
      </li>
    );
  }
}
